import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class BulkUploadRoute extends Route {
  @service
  students;

  model() {
    return hash({
      pendingUploads: this.students.updatePendingUploads(),
    });
  }
}
